import * as styles from './styles.css';

export interface ISectionProps {
  id?: string;
  name: string;
  state: string;
}

const state_text = {
  completed: 'Completed',
  in_progress: 'In Progress',
  incomplete: '',
};

const Section = ({ id, name, state }: ISectionProps) => {
  return (
    <div id={id} className={`${styles.section} ${styles.states[state] ?? ''}`}>
      <div className={styles.name}>{name}</div>
      <div className={styles.state}>{state_text[state] ?? ''}</div>
    </div>
  );
};

export default Section;
